import { render } from "./DataBerkas.vue?vue&type=template&id=a75f1da2"
import script from "./DataBerkas.vue?vue&type=script&lang=js"
export * from "./DataBerkas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__